export default "/assets/images/app-slider.mp4?8b8b940a359f4639f1265c4e249a5697";